export default "__VITE_ASSET__DDkk0k6U__"